import { BeforeProcessEndEventPayload } from '@mwe/features/wizard';
import { map, Observable, of, take } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { PopupService } from '@mwe/services';
import { Router } from '@angular/router';
import { ROUTE_UMMELDUNG_BESTAETIGUNG, ROUTE_UMMELDUNG_FILE_UPLOAD } from '../../../app.constants';
import { stepFormOf } from './wizardStepForm.util';
import { mapExitPopupResultToDecision, UMMELDUNG_EXIT_POPUP_RESULT, UmmeldungExitPopupDecision } from './exit-popup-decision';
import { UMMELDUNG_EXIT_POPUP, UMMELDUNG_INVALID_EXIT_POPUP } from '../../../config/popup/ummeldung-popup.config';

/**
 * Hook for `withConfirmExit`. Contract of the returned observable: emit `true` to PREVENT the
 * exit (stay in the wizard), `false` to allow it.
 *
 * Every exit goes through here — header ✕, "Abbrechen" and the close after "Speichern und später
 * fortsetzen" alike. The latter closes with reason `finished`, which the framework defines as
 * "no confirmation needed", so a save never triggers a second dialog.
 */
function ummeldungCustomConfirmExitDialog(event: BeforeProcessEndEventPayload): Observable<boolean> {
  if (event.reason === 'finished') {
    return of(false);
  }
  if (inject(Router).url.includes(ROUTE_UMMELDUNG_BESTAETIGUNG) || inject(Router).url.includes(ROUTE_UMMELDUNG_FILE_UPLOAD)) {
    return of(false);
  }

  openUmmeldungExitPopup(currentStepExitPopupType());
  return observeExitPopupDecision().pipe(map(decision => decision === UMMELDUNG_EXIT_POPUP_RESULT.stay));
}

function currentStepExitPopupType(): 'default' | 'invalid' {
  return (stepFormOf()?.touchAndValidate() ?? true) ? 'default' : 'invalid';
}

function observeExitPopupDecision(): Observable<UmmeldungExitPopupDecision> {
  return inject(PopupService).events().pipe(take(1), map(mapExitPopupResultToDecision));
}

function openUmmeldungExitPopup(exitPopupType: 'default' | 'invalid' = 'default'): void {
  const popupService = inject(PopupService);

  if (exitPopupType === 'invalid') {
    popupService.open({
      ...UMMELDUNG_INVALID_EXIT_POPUP,
      useCustomReturnValue: true,
      subscriptionId: UMMELDUNG_EXIT_POPUP_RESULT.discardAndExit,
    });
    return;
  }

  popupService.openV2({ ...UMMELDUNG_EXIT_POPUP, modalOpts: { injector: inject(Injector) } });
}

export { ummeldungCustomConfirmExitDialog };
